import { FC } from 'react';
import ISvgProps from '../SvgLoader/ISvgProps';

export const EmailSentIcon: FC<ISvgProps> = ({ primaryColor = '#37A264' }) => {
	return (
		<svg width="51" height="44" viewBox="0 0 51 44" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M46.4692 25.4737H41.8223V9.81432L23.4019 26.2564L4.64692 9.76337V37.0526H27.8815V41.6842H2.32346C1.70724 41.6842 1.11626 41.4402 0.680526 41.0059C0.244793 40.5716 0 39.9826 0 39.3684V2.31579C0 1.7016 0.244793 1.11257 0.680526 0.678279C1.11626 0.243984 1.70724 0 2.32346 0H44.1458C44.762 0 45.353 0.243984 45.7887 0.678279C46.2245 1.11257 46.4692 1.7016 46.4692 2.31579V25.4737ZM5.83421 4.63158L23.3764 20.0594L40.6652 4.63158H5.83421ZM39.4989 44L31.2831 35.8114L34.5708 32.5368L39.4989 37.451L47.7146 29.2623L51 32.5368L39.4989 44Z"
				fill={primaryColor}
			/>
		</svg>
	);
};
